
const mySwiper = new Swiper('.swiper', {
	// Optional parameters
	loop: true,
	effect:'fade',
	// fadeEffect: {
	// 	crossFade: true,
	// },
	autoplay: {
		delay: 5000,
	},
	speed: 2000,
	// If we need pagination
	pagination: {
		el: '.swiper-pagination',
	},

	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},

	// And if we need scrollbar
	scrollbar: {
		el: '.swiper-scrollbar',
	},
});

var loader = function () {
	loaderOverlay.classList.add('hide');
	var catchElm = document.querySelectorAll('.js_firstAnm');
	for(var i = 0; i < catchElm.length; i++) {
		catchElm[i].classList.add('show');
	}
}
if (loaderOverlay) {
	window.addEventListener('load', loader, false);
}

(function ($) {
	var headNav = $("header");
/* 初期表示、スクロール時にイベント開始 */
$(window).on("load scroll", function () {
    /* スクロール位置の高さが200pxより大きい、かつis-fixedクラスがない場合 */
	if ($(this).scrollTop() > 200 && headNav.hasClass("is-fixed") == false) {
        headNav.addClass("is-fixed");
        headNav.animate(600);
	}
    /* スクロール位置の高さが200pxより小さい、かつis-fixedクラスがある場合 */
	else if ($(this).scrollTop() < 200 && headNav.hasClass("is-fixed") == true) {
        headNav.removeClass("is-fixed");
	}
});
})(jQuery);





